// Opções para o campo Tipo de Operação de Crédito
export const CREDIT_OPERATION_TYPE_OPTIONS = [
    { value: 'AVAL SIMPLES', label: 'AVAL SIMPLES' },
    { value: 'AVAL DUPLO', label: 'AVAL DUPLO' },
    { value: 'FIRST LOSS', label: 'FIRST LOSS' },
    { value: 'FORFAITING', label: 'FORFAITING' },
    { value: 'CPRF PJ', label: 'CPRF PJ' },
    { value: 'CESSAO', label: 'CESSAO' },
    { value: 'CONTRACT_ASSIGNMENT', label: 'CESSAO DE CONTRATO' }
];
